import { IAutocompleteResults } from '../state-helpers/autocomplete';
import { GlobalActionType, IAction } from '../actions/index';

export class AutocompleteActionType extends GlobalActionType {
    static SET_AUTOCOMPLETE_ACTIVE: string = "SET_AUTOCOMPLETE_ACTIVE";
    static SET_AUTOCOMPLETE_ACTIVE_HIT: string = "SET_AUTOCOMPLETE_ACTIVE_HIT";
    static SET_AUTOCOMPLETE_HITS: string = "SET_AUTOCOMPLETE_HITS";
}

export interface IAutocompleteAction extends IAction {
    hits: string[];
    activeHit: number;
    isActive: boolean;
}

export function setAutocompleteHits(hits: string[]): IAutocompleteAction {
    return {
        type: AutocompleteActionType.SET_AUTOCOMPLETE_HITS,
        activeHit: -1,
        hits,
        isActive: false
    };
}

export function setActiveHit(activeHit: number): IAutocompleteAction {
    return {
        type: AutocompleteActionType.SET_AUTOCOMPLETE_ACTIVE_HIT,
        activeHit,
        isActive: false,
        hits: []
    };
}

export function setAutocompleteActive(isActive: boolean): IAutocompleteAction {
    return {
        type: AutocompleteActionType.SET_AUTOCOMPLETE_ACTIVE,
        isActive,
        activeHit: -1,
        hits: []
    }
}